module.exports = __webpack_public_path__ + "img/ico_editor_hyperlink_white.7702029f.svg";